import { Translate } from "../../constant/Translate"

const { TEXT_T280 } = Translate

export const summerTimeText = (value: string) =>
  value === "0" ? TEXT_T280 : ""

export const summerTimeValue = (isSummerTime?: boolean) =>
  isSummerTime ? "0" : "1"
